export const UnauthenticatedEmptyStateImage = () => null;
export const ErrorEmptyStateImage = () => null;
